import { createShorthandFactory } from '@flowio/react-helpers';
import Avatar from '../components/Avatar';
export default createShorthandFactory(Avatar, function (value) {
  if (typeof value !== 'string') {
    return null;
  }

  return {
    accessibilityLabel: 'No accessibility label provided',
    source: value
  };
});